import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { KapOrgIcon2, SuccessPurchaseIcon, BackIconWhiteColor } from "../../assets/icons";
import { Button } from "antd";
import "./style.scss";
import { useTranslation } from "../../i18n/LanguageContext";

const SuccessPaymentInfo = () => {
   const { t } = useTranslation();
   const navigate = useNavigate();
   return (
      <div
         className="full-page-background"
         style={{
            backgroundImage: `url(${toAbsoluteUrl("/media/bg/loginbackground.svg")})`
         }}
      >
         <Link to="/" className="logo-link">
            <img alt="Logo" className="logo" src={KapOrgIcon2} />
         </Link>
         <div className="centered-box">
            <img src={SuccessPurchaseIcon} alt="SuccessPurchaseIcon" />
            <h1>{t("purchase-successful-title")}</h1>
            <p>{t("payment-processed-success-text")}</p>
            <span>{t("thank-you-for-purchase-text")}</span>
            <Button
               className="back-to-payment-info-button"
               htmlType="submit"
               style={{ width: "fit-content", color: "#fff" }}
               onClick={() => navigate("/admin/payment-information")}
            >
               <div className="button-info">
                  <img src={BackIconWhiteColor} alt="BackIconWhiteColor" />
                  <div className="back-to-payment-info-text">{t("go-back-to-payment-info-text")}</div>
               </div>
            </Button>
         </div>
      </div>
   );
};

export default SuccessPaymentInfo;
